module.exports = __webpack_public_path__ + "r-s3.png?59cfcebc64138eba68f687c00ceffcd9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r-s3.png
// module id = 67
// module chunks = 0